export const CPG_JOBS_APP_URL = 'https://app.cpgjobs.com';

const EMPLOYER_LISTINGS_PATH = '/user/employer/listings';
const EMPLOYER_PACKAGES_PATH = '/user/employer/packages';

export const cpgJobsUrls = {
  listings: `${CPG_JOBS_APP_URL}${EMPLOYER_LISTINGS_PATH}`,
  packages: `${CPG_JOBS_APP_URL}${EMPLOYER_PACKAGES_PATH}`,
};

const appendSearchAndHash = (
  path: string,
  search = '',
  hash = '',
): string => `${CPG_JOBS_APP_URL}${path}${search}${hash}`;

const withQueryValue = (
  path: string,
  search: string,
  key: string,
  value: string,
  hash: string,
): string => {
  const params = new URLSearchParams(search);
  params.set(key, value);
  const query = params.toString();
  return appendSearchAndHash(path, query ? `?${query}` : '', hash);
};

const brandSegment = (siteId: string): string => {
  if (siteId === '2') return '/brewbound';
  if (siteId === '3') return '/nosh';
  return '';
};

/**
 * Maps every retired Account-front Jobs route to the equivalent route in the
 * CPG Jobs app. Saved links continue to work without loading the legacy feature.
 */
export const getCpgJobsRedirectUrl = (
  pathname: string,
  search = '',
  hash = '',
): string => {
  if (pathname === '/user/jobsApplicants') {
    return appendSearchAndHash(EMPLOYER_LISTINGS_PATH, search, hash);
  }

  if (pathname === '/user/jobslistings') {
    return appendSearchAndHash(EMPLOYER_LISTINGS_PATH, search, hash);
  }

  if (pathname === '/user/jobsprepaid') {
    return appendSearchAndHash(EMPLOYER_PACKAGES_PATH, search, hash);
  }

  const packageDetailMatch = pathname.match(/^\/user\/jobsprepaid\/([^/]+)$/);
  if (packageDetailMatch) {
    return appendSearchAndHash(
      `${EMPLOYER_PACKAGES_PATH}/${packageDetailMatch[1]}`,
      search,
      hash,
    );
  }

  const applicantsMatch = pathname.match(/^\/user\/jobsApplicants\/([^/]+)$/);
  if (applicantsMatch) {
    return appendSearchAndHash(
      `${EMPLOYER_LISTINGS_PATH}/${applicantsMatch[1]}/applicants`,
      search,
      hash,
    );
  }

  const applicantDetailMatch = pathname.match(
    /^\/user\/jobsApplicantDetail\/([^/]+)\/([^/]+)$/,
  );
  if (applicantDetailMatch) {
    return appendSearchAndHash(
      `${EMPLOYER_LISTINGS_PATH}/${applicantDetailMatch[1]}/applicants/${applicantDetailMatch[2]}`,
      search,
      hash,
    );
  }

  if (pathname === '/user/jobs/post') {
    return appendSearchAndHash('/PostJobListing', search, hash);
  }

  const editMatch = pathname.match(/^\/user\/jobs\/edit\/([^/]+)$/);
  if (editMatch) {
    return appendSearchAndHash(
      `/jobs/EditJob/${editMatch[1]}`,
      search,
      hash,
    );
  }

  const reactivateMatch = pathname.match(/^\/user\/jobs\/reactivate\/([^/]+)$/);
  if (reactivateMatch) {
    return withQueryValue(
      '/jobs/reactivatelisting',
      search,
      'path',
      reactivateMatch[1],
      hash,
    );
  }

  const upgradeMatch = pathname.match(/^\/user\/jobs\/upgrade\/([^/]+)\/([^/]+)$/);
  if (upgradeMatch) {
    return appendSearchAndHash(
      `/jobs/upgradelisting${brandSegment(upgradeMatch[1])}/${upgradeMatch[2]}`,
      search,
      hash,
    );
  }

  const prepaidMatch = pathname.match(/^\/user\/jobs\/prepaid\/([^/]+)$/);
  if (prepaidMatch) {
    return appendSearchAndHash(
      `/jobs/postprepaidlisting/${prepaidMatch[1]}`,
      search,
      hash,
    );
  }

  const receiptMatch = pathname.match(/^\/user\/jobs\/receipt\/([^/]+)$/);
  if (receiptMatch) {
    return withQueryValue('/jobs/receipt', search, 'eguid', receiptMatch[1], hash);
  }

  if (pathname === '/user/jobs/no-remaining') {
    return appendSearchAndHash('/jobs/noremaining', search, hash);
  }

  if (pathname === '/user/jobs/prepaid-expired') {
    return appendSearchAndHash('/jobs/prepaidlistingexpired', search, hash);
  }

  return appendSearchAndHash(EMPLOYER_LISTINGS_PATH, search, hash);
};
